<template>
  <div class="metricNameContainer pe-24">
    <div class="inputBox">
      <div class="metricNameTitle">
        {{ $util.capitalize($t('label.metricName')) }}
        <span class="required">*</span>
      </div>
      <lego-text-field
        ref="metricNameRef"
        :modelValue="props.name"
        @update:modelValue="changeMetricName"
        :mutateInput="hanldeMetricName"
        class="metricInput"
        counter="87"
        showCounter
        :guide="$t('hint.guideMetric')"
        :rules="[validatorInputMetricName]"
      />
      <div class="metricfilter">metricfilter.</div>
    </div>
    <div class="inputBox">
      <div class="metricNameTitle">
        {{ $util.capitalize($t('label.description')) }}
      </div>
      <lego-text-field
        ref="metricDescription"
        :modelValue="props.description"
        @update:modelValue="changeMetricDescription"
        class="metricInput"
        :counter="1000"
        showCounter
        :rows="6"
        textarea
        :rules="[validatorInputDescription]"
        :guide="$t('hint.common')"
      />
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, defineExpose, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';
import { constant } from '@/utils/constant.js';
const $util = getCurrentInstance().appContext.config.globalProperties.$util;
const { t } = useI18n();
//emits
const emits = defineEmits(['update:name', 'update:description']);

const metricNameRef = ref();
const firstDotIndex = ref(0);
const props = defineProps({
  name: { type: String },
  description: { type: String }
});

const changeMetricName = (value) => {
  emits('update:name', value);
};

const changeMetricDescription = (value) => {
  emits('update:description', value);
};

const validatorInputMetricName = (value) => {
  if (!value.length) return t('message.requiredInput');
  if (/[^A-Za-z._]/.test(value)) return t('message.errorValidateInput');
  return true;
};

const validatorInputDescription = (value) => {
  if (/[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s.]/g.test(value)) return t('message.errorValidateInput');
  return true;
};

const validateMetricName = () => {
  return metricNameRef.value;
};

defineExpose({
  validateMetricName
});

const hanldeMetricName = (value) => {
  const { val, beforeDotIndex } = $util.validatorInputMetric(value, firstDotIndex.value);
  firstDotIndex.value = beforeDotIndex;
  return val;
};
</script>

<style lang="scss" scoped>
.metricNameContainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.inputBox {
  &:first-child {
    position: relative;
    .metricfilter {
      position: absolute;
      top: 46px;
      left: 12px;
    }
    // :deep(.lego-text-field__message.lego-text-field__message--light) {
    //   .lego-text-field__counter {
    //     color: #adadad;
    //   }
    // }
  }
  .metricNameTitle {
    height: 32px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    color: #2e3138;
    font-weight: 500;
    .required {
      color: #ff0000;
      margin-left: 2px;
    }
  }
}
</style>
